// actions.js
export const SET_USER_ID = 'SET_USER_ID';

export const setUserId = (userId) => ({
  type: SET_USER_ID,
  payload: userId,
});
